<template>
	<div class="dialog light" style="min-height: fit-content;">
		<div class="dialog-title d-flex flex-align-center flex-row">
			<span class="icon p-0 mr-3" style="height: 20px;">
				<img src="/assets/img/icons/logo_remote.svg" />
			</span>
			<span>{{ $t("Connect to {0}", { 0: ir_info.id_remote }) }}</span>
		</div>

		<form class="dialog-content d-flex flex-column flex-justify-center flex-align-center" @submit.prevent="confirmPassword">
			<b class="mb-4">{{ $t("Insert password") }}</b>
			<input type="password" v-model="typedCustomPassword" class="input w-75" :placeholder="$t('Enter the custom password')" autofocus />
		</form>

		<div class="dialog-actions">
			<button class="button secondary my-3" @click="confirmPassword" :disabled="isChecking || typedCustomPassword == ''">
				{{ $t("Connect") }}
			</button>
			<button class="button js-dialog-close" @click="close">{{ $t("Close") }}</button>
		</div>
	</div>
</template>

<script>
import { sha256 } from '../../utils/utilitiesmodule';

export default {
	name: "IperiusRemoteConnection",
	props: {
		ir_info: Object
	},
	data() {
		return {
			typedCustomPassword: "",
			isChecking: false
		}
	},
	methods: {
		async confirmPassword() {
			if (this.isChecking || this.typedCustomPassword == '') return;

			this.isChecking = true;
			const encryptedPassword = (await sha256(this.typedCustomPassword)).toUpperCase();
			this.isChecking = false;

			if (this.ir_info.custom_password != encryptedPassword) {
				this.$root.toast(this.$t("The password you entered is incorrect"), "alert");
				return;
			}

			const onConfirmed = this.ir_info.onConfirmed;
			this.close();
			if (typeof onConfirmed === 'function') await onConfirmed();
		},

		close() {
			this.$root.$emit('CLOSEIRCONNECTION');
		}
	}
}
</script>
